<script setup lang="ts">
import type { ReportPaginationChange, ReportPaginationProps } from './types'

import { useI18n } from '@/shared/i18n'
import { Pagination } from '@/shared/ui'

const props = withDefaults(defineProps<ReportPaginationProps>(), {
  pageSizes: () => [10, 25, 50, 100],
})
const emit = defineEmits<{
  'update:first': [first: number]
  'update:rows': [rows: number]
  change: [payload: ReportPaginationChange]
}>()

const { t } = useI18n()

function onChange(payload: ReportPaginationChange): void {
  const firstChanged = payload.first !== props.first
  const rowsChanged = payload.rows !== props.rows
  if (!firstChanged && !rowsChanged) return

  if (firstChanged) emit('update:first', payload.first)
  if (rowsChanged) emit('update:rows', payload.rows)
  emit('change', payload)
}
</script>

<template>
  <Pagination
    :total="total"
    :first="first"
    :rows="rows"
    :page-sizes="pageSizes"
    :first-label="t('reports.table.pagination.first')"
    :prev-label="t('reports.table.pagination.previous')"
    :next-label="t('reports.table.pagination.next')"
    :last-label="t('reports.table.pagination.last')"
    :rows-label="t('reports.table.pagination.rowsPerPage')"
    @change="onChange"
  />
</template>
